import { Colleague } from "../../../../features/Connections/types/Colleague.type";

export const USER_REQUIRED_MESSAGE = "Select a user to book on behalf";

/**
 * Result of validating user for a book-on-behalf row.
 * Used by FleetManagementEventDetailTable to update validation errors.
 */
export type ValidateUserForRowResult =
  | { valid: true; clearError: true }
  | { valid: false; errorMessage: string };

/**
 * Pure validation: returns whether the user is valid and how to update validation errors.
 * Does not depend on setState or t; the caller applies the result.
 */
export function validateUserForRowLogic(
  _rowId: string,
  user: Colleague | null | undefined
): ValidateUserForRowResult {
  if (user?.userId) {
    return { valid: true, clearError: true };
  }
  return { valid: false, errorMessage: USER_REQUIRED_MESSAGE };
}
